import styled from "@emotion/styled"
import { Dialog } from "radix-ui"
import VideoPlayer from "app/core/components/VideoPlayer"
import { DARK_BLUE_COLOR } from "theme/colors"
import { MODAL_Z_INDEX } from "theme/consts"
import CloseButtonBase from "ui/CloseButton"
import {
  Content as ContentBase,
  Overlay as OverlayBase,
  Root as RootBase,
} from "ui/Modal"
import { FileWithVariants } from "utils/files/types"

const SUPPORT_VIDEO_Z_INDEX = MODAL_Z_INDEX + 3

const Root = styled(RootBase)`
  z-index: ${SUPPORT_VIDEO_Z_INDEX};
  overflow: unset;
  padding: 8px;
  border: 1px solid ${DARK_BLUE_COLOR};
`

const Content = styled(ContentBase)`
  padding: 0;
  border: 1px solid ${DARK_BLUE_COLOR};
  border-radius: 12px;
  position: relative;
  z-index: ${SUPPORT_VIDEO_Z_INDEX};
`

const CloseButton = styled(CloseButtonBase)`
  position: fixed;
  top: -16px;
  right: -16px;
  z-index: ${SUPPORT_VIDEO_Z_INDEX};
`

const Overlay = styled(OverlayBase)`
  background-color: ${DARK_BLUE_COLOR};
  opacity: 0.5;
  z-index: ${SUPPORT_VIDEO_Z_INDEX};
`

const SupportVideo = ({
  video,
  onClose,
  onTimeUpdate,
  videoRef,
}: {
  video: FileWithVariants
  onClose: () => void
  onTimeUpdate?: () => void
  videoRef?: React.RefObject<HTMLVideoElement | null>
}) => {
  return (
    <Dialog.Portal>
      <Dialog.Overlay asChild>
        <Overlay />
      </Dialog.Overlay>
      <Dialog.Content>
        <Root width="940px">
          <Content>
            <div className="aspect-video w-full">
              <VideoPlayer
                file={video}
                onTimeUpdate={onTimeUpdate}
                ref={videoRef}
              />
            </div>
          </Content>
          <CloseButton isOpen={false} onClick={onClose} />
        </Root>
      </Dialog.Content>
    </Dialog.Portal>
  )
}

export default SupportVideo
